import Vue from "vue";
const api_path = "/users";

export async function mudarPermissaoLocacao(user_id, payload) {
  const response = await Vue.prototype.$http.post(
    `${api_path}/${user_id}/atribuir_permissao_locacao`,
    payload
  );

  return response.data;
}
